<form class="modal-container" [formGroup]="form">
  <div class="modal-exit">
    <button type="button" class="btn-close" aria-label="Close" (click)="onClose()"></button>
  </div>
  <div class="modal-info">
    <div class="modal-title">{{'CANCEL_SERVICE_MODAL.title' | translate}}</div>
    <div class="modal-description">{{'CANCEL_SERVICE_MODAL.description' | translate}}</div>
  </div>

  <div class="dropdown-container">
    <app-dropdown-select [DataArray]="reasons" [KeyId]="'id'" [KeyName]="['code']"
      [TranslateKey]="'CANCEL_SERVICE_MODAL.'" [Placeholder]="('CANCEL_SERVICE_MODAL.select_reason' | translate)"
      [SelectedObject]="form.get('reasonCode')?.value" [useIdAsModel]="true" [Loading]="reasonsLoading"
      [Error]="!!(form.get('reasonCode')?.touched && form.get('reasonCode')?.invalid)"
      (optionEmitter)="form.get('reasonCode')?.setValue($event)"></app-dropdown-select>
  </div>

  <div class="modal-buttons">
    <button type="button" class="button-white" (click)="onClose()">
      {{'CANCEL_SERVICE_MODAL.close' | translate}}
    </button>
    <button type="button" [class.button-disable]="form.invalid" class="button-red" (click)="cancelServiceRequest()">
      {{'CANCEL_SERVICE_MODAL.cancel' | translate}}
    </button>
    <img *ngIf="CancelLoading" style="width: 25px;" src="../../../../../assets/gifs/loading-spinner.gif" alt="">
  </div>
</form>